import {NgModule} from "@angular/core";
import {Route, RouterModule, Routes} from "@angular/router";
import {IgSubRoutes} from "./ig/ig.route";


export function getRouters(): { name: string; routeMethod: () => Routes }[] {
    return [
        {name : "ig", routeMethod: IgSubRoutes },
    ];
}

function collectSubRoutes(): Route[] {
    const routes: Route[] = [];
    const crmRouters = getRouters();
    for (const router of crmRouters) {
        const subRoutes = router.routeMethod();
        if (subRoutes) {
            routes.push(...subRoutes);
        }
    }
    return routes;
}

const routes: Routes = [
    {
        path: '',
        children: collectSubRoutes(),
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)], // ✅ forChild for lazy module
    exports: [RouterModule],
})
export class FeatureAuthRoutingModule {}
